import type React from "react";
import type { MemberAttribute } from "../../../shared/types/member.types";
import { MemberAttributeFilters } from "../components/MemberAttributeFilters";
import { FILTER_PRESETS } from "../config/filterPresets";

interface MemberBrowseFiltersProps {
	memberAttributes: MemberAttribute[];
}

export const MemberAttributeBrowseFilters: React.FC<
	MemberBrowseFiltersProps
> = ({ memberAttributes }) => (
	<MemberAttributeFilters
		memberAttributes={memberAttributes}
		config={FILTER_PRESETS.memberBrowse}
	/>
);
